module.exports = __webpack_public_path__ + "img/my-invoice-select.af0b433e.svg";